export default class Style {
  constructor() {
    $(document).ready(function() {
      // SCROLL FIXED HEADER
        $(window).scroll(function () {
            if (window.matchMedia("(min-width: 767px)").matches) {
                if ($(window).scrollTop() > 90) {
                    $('header .container-full').addClass('fixed');
                } else {
                    $('header .container-full').removeClass('fixed');
                }
            } else {
                if ($(window).scrollTop() > 30) {
                    $('header .container-full').addClass('fixed');
                } else {
                    $('header .container-full').removeClass('fixed');
                }
            }
        });

    });
  }
}
